<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control" v-bind:disabled="deshabilitado" @change="cambiarDatos($event)">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un tipo de acto reclamado</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los tipos de acto reclamado</option>
        <option v-for="TipoDeActoReclamado in TiposDeActoReclamado" v-bind:key="TipoDeActoReclamado.tipoDeActoReclamadoId" :value="TipoDeActoReclamado.tipoDeActoReclamadoId" >{{TipoDeActoReclamado.nombre}}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import axios from 'axios';
  import api from '@/../static/js/api';
  import comun from '@/../static/js/comun';

  export default {
    data() {
      return {
        enumeraciones,
        comun,
        TiposDeActoReclamado: [],
        idDelModelo: null
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      idDelInput: String,
      valorDefinido: Number,
      parametros: Object,
      deshabilitado: false
    },
    mounted() {
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }

      //this.$store.dispatch(""A_SIFA_Catalogo_Establecer003TipoDeActoReclamado", parametros);
    },
    methods: {
      cargaCatalogoTiposDeActoReclamado() {
        
      console.log(this.parametros)
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {}
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba
        axios.post(api.conexion + api.SIFA.catalogos.C003TiposDeActoReclamado, this.parametros).then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              this.TiposDeActoReclamado = respuesta.data.TiposDeActoReclamado;

              if (this.parametros.filtros != undefined && this.parametros.filtros != null) {
                this.TiposDeActoReclamado = respuesta.data.TiposDeActoReclamado.filter(cond => this.parametros.filtros.some(tiposDeActoReclamado => tiposDeActoReclamado == cond.tiposDeActoReclamadoId));
              }
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })
      },
      cambiarDatos(evento) {
        this.idDelModelo = evento.target.value;
        const parametros = {
          llave: this.idDelInput,
          valor: evento.target.value
        }
        //console.log(evento)
        this.$store.dispatch("A_SIFA_Catalogo_Establecer003TipoDeActoReclamado", parametros);
        this.$emit("valorParaElPadre", [evento, this.TiposDeActoReclamado[evento.target.selectedIndex -1]]);

        //evento.target[evento.target.selectedIndex].label esto sirve para obtener el label de valor actual
      }
    },
    created() {
      this.cargaCatalogoTiposDeActoReclamado();
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SIFA/Comun/Catalogos/C003TiposDeActoReclamado.vue